/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as JoinRouteImport } from './routes/join'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthTicketScannerRouteImport } from './routes/_auth/ticket/scanner'
import { Route as AuthTicketTicketIdRouteImport } from './routes/_auth/ticket/$ticketId'
import { Route as AuthOrgOrgIdRouteRouteImport } from './routes/_auth/org/$orgId/route'
import { Route as AuthOrgOrgIdIndexRouteImport } from './routes/_auth/org/$orgId/index'
import { Route as AuthUserIdQuizRouteImport } from './routes/_auth/user/$id/quiz'
import { Route as AuthOrgOrgIdPreviewRouteImport } from './routes/_auth/org/$orgId/preview'
import { Route as AuthOrgOrgIdReferralsIndexRouteImport } from './routes/_auth/org/$orgId/referrals/index'
import { Route as AuthOrgOrgIdMembersIndexRouteImport } from './routes/_auth/org/$orgId/members/index'
import { Route as AuthOrgOrgIdLocationsIndexRouteImport } from './routes/_auth/org/$orgId/locations/index'
import { Route as AuthOrgOrgIdEventIndexRouteImport } from './routes/_auth/org/$orgId/event/index'
import { Route as AuthOrgOrgIdEditIndexRouteImport } from './routes/_auth/org/$orgId/edit/index'
import { Route as AuthOrgOrgIdEventEventIdRouteRouteImport } from './routes/_auth/org/$orgId/event/$eventId/route'
import { Route as AuthOrgOrgIdEventCreateIndexRouteImport } from './routes/_auth/org/$orgId/event/create/index'
import { Route as AuthOrgOrgIdEventEventIdIndexRouteImport } from './routes/_auth/org/$orgId/event/$eventId/index'
import { Route as AuthOrgOrgIdEventEventIdSessionsIndexRouteImport } from './routes/_auth/org/$orgId/event/$eventId/sessions/index'
import { Route as AuthOrgOrgIdEventEventIdQuestionsIndexRouteImport } from './routes/_auth/org/$orgId/event/$eventId/questions/index'
import { Route as AuthOrgOrgIdEventEventIdEditIndexRouteImport } from './routes/_auth/org/$orgId/event/$eventId/edit/index'
import { Route as AuthOrgOrgIdEventEventIdAttendeesIndexRouteImport } from './routes/_auth/org/$orgId/event/$eventId/attendees/index'

const QrLazyRouteImport = createFileRoute('/qr')()
const LandingIndexLazyRouteImport = createFileRoute('/_landing/')()
const InfoTermsLazyRouteImport = createFileRoute('/_info/terms')()
const InfoPrivacyLazyRouteImport = createFileRoute('/_info/privacy')()
const InfoAboutUsLazyRouteImport = createFileRoute('/_info/about-us')()
const AuthHomeIndexLazyRouteImport = createFileRoute('/_auth/home/')()
const AuthOrgCreateLazyRouteImport = createFileRoute('/_auth/org/create')()
const AuthUserIdWalletLazyRouteImport = createFileRoute(
  '/_auth/user/$id/wallet',
)()
const AuthUserIdProfileLazyRouteImport = createFileRoute(
  '/_auth/user/$id/profile',
)()
const AuthOrgOrgIdLocationCreateLazyRouteImport = createFileRoute(
  '/_auth/org/$orgId/location/create',
)()

const QrLazyRoute = QrLazyRouteImport.update({
  id: '/qr',
  path: '/qr',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/qr.lazy').then((d) => d.Route))
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/join.lazy').then((d) => d.Route))
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingIndexLazyRoute = LandingIndexLazyRouteImport.update({
  id: '/_landing/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/_landing/index.lazy').then((d) => d.Route),
)
const InfoTermsLazyRoute = InfoTermsLazyRouteImport.update({
  id: '/_info/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_info/terms.lazy').then((d) => d.Route))
const InfoPrivacyLazyRoute = InfoPrivacyLazyRouteImport.update({
  id: '/_info/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_info/privacy.lazy').then((d) => d.Route))
const InfoAboutUsLazyRoute = InfoAboutUsLazyRouteImport.update({
  id: '/_info/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/_info/about-us.lazy').then((d) => d.Route),
)
const AuthHomeIndexLazyRoute = AuthHomeIndexLazyRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/home/index.lazy').then((d) => d.Route),
)
const AuthOrgCreateLazyRoute = AuthOrgCreateLazyRouteImport.update({
  id: '/org/create',
  path: '/org/create',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/org/create.lazy').then((d) => d.Route),
)
const AuthTicketScannerRoute = AuthTicketScannerRouteImport.update({
  id: '/ticket/scanner',
  path: '/ticket/scanner',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthTicketTicketIdRoute = AuthTicketTicketIdRouteImport.update({
  id: '/ticket/$ticketId',
  path: '/ticket/$ticketId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrgOrgIdRouteRoute = AuthOrgOrgIdRouteRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrgOrgIdIndexRoute = AuthOrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgOrgIdRouteRoute,
} as any)
const AuthUserIdWalletLazyRoute = AuthUserIdWalletLazyRouteImport.update({
  id: '/user/$id/wallet',
  path: '/user/$id/wallet',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/user/$id/wallet.lazy').then((d) => d.Route),
)
const AuthUserIdProfileLazyRoute = AuthUserIdProfileLazyRouteImport.update({
  id: '/user/$id/profile',
  path: '/user/$id/profile',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/user/$id/profile.lazy').then((d) => d.Route),
)
const AuthUserIdQuizRoute = AuthUserIdQuizRouteImport.update({
  id: '/user/$id/quiz',
  path: '/user/$id/quiz',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrgOrgIdPreviewRoute = AuthOrgOrgIdPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => AuthOrgOrgIdRouteRoute,
} as any)
const AuthOrgOrgIdReferralsIndexRoute =
  AuthOrgOrgIdReferralsIndexRouteImport.update({
    id: '/referrals/',
    path: '/referrals/',
    getParentRoute: () => AuthOrgOrgIdRouteRoute,
  } as any)
const AuthOrgOrgIdMembersIndexRoute =
  AuthOrgOrgIdMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthOrgOrgIdRouteRoute,
  } as any)
const AuthOrgOrgIdLocationsIndexRoute =
  AuthOrgOrgIdLocationsIndexRouteImport.update({
    id: '/locations/',
    path: '/locations/',
    getParentRoute: () => AuthOrgOrgIdRouteRoute,
  } as any)
const AuthOrgOrgIdEventIndexRoute = AuthOrgOrgIdEventIndexRouteImport.update({
  id: '/event/',
  path: '/event/',
  getParentRoute: () => AuthOrgOrgIdRouteRoute,
} as any)
const AuthOrgOrgIdEditIndexRoute = AuthOrgOrgIdEditIndexRouteImport.update({
  id: '/edit/',
  path: '/edit/',
  getParentRoute: () => AuthOrgOrgIdRouteRoute,
} as any)
const AuthOrgOrgIdLocationCreateLazyRoute =
  AuthOrgOrgIdLocationCreateLazyRouteImport.update({
    id: '/location/create',
    path: '/location/create',
    getParentRoute: () => AuthOrgOrgIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/org/$orgId/location/create.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthOrgOrgIdEventEventIdRouteRoute =
  AuthOrgOrgIdEventEventIdRouteRouteImport.update({
    id: '/event/$eventId',
    path: '/event/$eventId',
    getParentRoute: () => AuthOrgOrgIdRouteRoute,
  } as any)
const AuthOrgOrgIdEventCreateIndexRoute =
  AuthOrgOrgIdEventCreateIndexRouteImport.update({
    id: '/event/create/',
    path: '/event/create/',
    getParentRoute: () => AuthOrgOrgIdRouteRoute,
  } as any)
const AuthOrgOrgIdEventEventIdIndexRoute =
  AuthOrgOrgIdEventEventIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgOrgIdEventEventIdRouteRoute,
  } as any)
const AuthOrgOrgIdEventEventIdSessionsIndexRoute =
  AuthOrgOrgIdEventEventIdSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => AuthOrgOrgIdEventEventIdRouteRoute,
  } as any)
const AuthOrgOrgIdEventEventIdQuestionsIndexRoute =
  AuthOrgOrgIdEventEventIdQuestionsIndexRouteImport.update({
    id: '/questions/',
    path: '/questions/',
    getParentRoute: () => AuthOrgOrgIdEventEventIdRouteRoute,
  } as any)
const AuthOrgOrgIdEventEventIdEditIndexRoute =
  AuthOrgOrgIdEventEventIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => AuthOrgOrgIdEventEventIdRouteRoute,
  } as any)
const AuthOrgOrgIdEventEventIdAttendeesIndexRoute =
  AuthOrgOrgIdEventEventIdAttendeesIndexRouteImport.update({
    id: '/attendees/',
    path: '/attendees/',
    getParentRoute: () => AuthOrgOrgIdEventEventIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/join': typeof JoinRoute
  '/qr': typeof QrLazyRoute
  '/about-us': typeof InfoAboutUsLazyRoute
  '/privacy': typeof InfoPrivacyLazyRoute
  '/terms': typeof InfoTermsLazyRoute
  '/': typeof LandingIndexLazyRoute
  '/org/$orgId': typeof AuthOrgOrgIdRouteRouteWithChildren
  '/ticket/$ticketId': typeof AuthTicketTicketIdRoute
  '/ticket/scanner': typeof AuthTicketScannerRoute
  '/org/create': typeof AuthOrgCreateLazyRoute
  '/home': typeof AuthHomeIndexLazyRoute
  '/org/$orgId/preview': typeof AuthOrgOrgIdPreviewRoute
  '/user/$id/quiz': typeof AuthUserIdQuizRoute
  '/user/$id/profile': typeof AuthUserIdProfileLazyRoute
  '/user/$id/wallet': typeof AuthUserIdWalletLazyRoute
  '/org/$orgId/': typeof AuthOrgOrgIdIndexRoute
  '/org/$orgId/event/$eventId': typeof AuthOrgOrgIdEventEventIdRouteRouteWithChildren
  '/org/$orgId/location/create': typeof AuthOrgOrgIdLocationCreateLazyRoute
  '/org/$orgId/edit': typeof AuthOrgOrgIdEditIndexRoute
  '/org/$orgId/event': typeof AuthOrgOrgIdEventIndexRoute
  '/org/$orgId/locations': typeof AuthOrgOrgIdLocationsIndexRoute
  '/org/$orgId/members': typeof AuthOrgOrgIdMembersIndexRoute
  '/org/$orgId/referrals': typeof AuthOrgOrgIdReferralsIndexRoute
  '/org/$orgId/event/$eventId/': typeof AuthOrgOrgIdEventEventIdIndexRoute
  '/org/$orgId/event/create': typeof AuthOrgOrgIdEventCreateIndexRoute
  '/org/$orgId/event/$eventId/attendees': typeof AuthOrgOrgIdEventEventIdAttendeesIndexRoute
  '/org/$orgId/event/$eventId/edit': typeof AuthOrgOrgIdEventEventIdEditIndexRoute
  '/org/$orgId/event/$eventId/questions': typeof AuthOrgOrgIdEventEventIdQuestionsIndexRoute
  '/org/$orgId/event/$eventId/sessions': typeof AuthOrgOrgIdEventEventIdSessionsIndexRoute
}
export interface FileRoutesByTo {
  '/join': typeof JoinRoute
  '/qr': typeof QrLazyRoute
  '/about-us': typeof InfoAboutUsLazyRoute
  '/privacy': typeof InfoPrivacyLazyRoute
  '/terms': typeof InfoTermsLazyRoute
  '/': typeof LandingIndexLazyRoute
  '/ticket/$ticketId': typeof AuthTicketTicketIdRoute
  '/ticket/scanner': typeof AuthTicketScannerRoute
  '/org/create': typeof AuthOrgCreateLazyRoute
  '/home': typeof AuthHomeIndexLazyRoute
  '/org/$orgId/preview': typeof AuthOrgOrgIdPreviewRoute
  '/user/$id/quiz': typeof AuthUserIdQuizRoute
  '/user/$id/profile': typeof AuthUserIdProfileLazyRoute
  '/user/$id/wallet': typeof AuthUserIdWalletLazyRoute
  '/org/$orgId': typeof AuthOrgOrgIdIndexRoute
  '/org/$orgId/location/create': typeof AuthOrgOrgIdLocationCreateLazyRoute
  '/org/$orgId/edit': typeof AuthOrgOrgIdEditIndexRoute
  '/org/$orgId/event': typeof AuthOrgOrgIdEventIndexRoute
  '/org/$orgId/locations': typeof AuthOrgOrgIdLocationsIndexRoute
  '/org/$orgId/members': typeof AuthOrgOrgIdMembersIndexRoute
  '/org/$orgId/referrals': typeof AuthOrgOrgIdReferralsIndexRoute
  '/org/$orgId/event/$eventId': typeof AuthOrgOrgIdEventEventIdIndexRoute
  '/org/$orgId/event/create': typeof AuthOrgOrgIdEventCreateIndexRoute
  '/org/$orgId/event/$eventId/attendees': typeof AuthOrgOrgIdEventEventIdAttendeesIndexRoute
  '/org/$orgId/event/$eventId/edit': typeof AuthOrgOrgIdEventEventIdEditIndexRoute
  '/org/$orgId/event/$eventId/questions': typeof AuthOrgOrgIdEventEventIdQuestionsIndexRoute
  '/org/$orgId/event/$eventId/sessions': typeof AuthOrgOrgIdEventEventIdSessionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/qr': typeof QrLazyRoute
  '/_info/about-us': typeof InfoAboutUsLazyRoute
  '/_info/privacy': typeof InfoPrivacyLazyRoute
  '/_info/terms': typeof InfoTermsLazyRoute
  '/_landing/': typeof LandingIndexLazyRoute
  '/_auth/org/$orgId': typeof AuthOrgOrgIdRouteRouteWithChildren
  '/_auth/ticket/$ticketId': typeof AuthTicketTicketIdRoute
  '/_auth/ticket/scanner': typeof AuthTicketScannerRoute
  '/_auth/org/create': typeof AuthOrgCreateLazyRoute
  '/_auth/home/': typeof AuthHomeIndexLazyRoute
  '/_auth/org/$orgId/preview': typeof AuthOrgOrgIdPreviewRoute
  '/_auth/user/$id/quiz': typeof AuthUserIdQuizRoute
  '/_auth/user/$id/profile': typeof AuthUserIdProfileLazyRoute
  '/_auth/user/$id/wallet': typeof AuthUserIdWalletLazyRoute
  '/_auth/org/$orgId/': typeof AuthOrgOrgIdIndexRoute
  '/_auth/org/$orgId/event/$eventId': typeof AuthOrgOrgIdEventEventIdRouteRouteWithChildren
  '/_auth/org/$orgId/location/create': typeof AuthOrgOrgIdLocationCreateLazyRoute
  '/_auth/org/$orgId/edit/': typeof AuthOrgOrgIdEditIndexRoute
  '/_auth/org/$orgId/event/': typeof AuthOrgOrgIdEventIndexRoute
  '/_auth/org/$orgId/locations/': typeof AuthOrgOrgIdLocationsIndexRoute
  '/_auth/org/$orgId/members/': typeof AuthOrgOrgIdMembersIndexRoute
  '/_auth/org/$orgId/referrals/': typeof AuthOrgOrgIdReferralsIndexRoute
  '/_auth/org/$orgId/event/$eventId/': typeof AuthOrgOrgIdEventEventIdIndexRoute
  '/_auth/org/$orgId/event/create/': typeof AuthOrgOrgIdEventCreateIndexRoute
  '/_auth/org/$orgId/event/$eventId/attendees/': typeof AuthOrgOrgIdEventEventIdAttendeesIndexRoute
  '/_auth/org/$orgId/event/$eventId/edit/': typeof AuthOrgOrgIdEventEventIdEditIndexRoute
  '/_auth/org/$orgId/event/$eventId/questions/': typeof AuthOrgOrgIdEventEventIdQuestionsIndexRoute
  '/_auth/org/$orgId/event/$eventId/sessions/': typeof AuthOrgOrgIdEventEventIdSessionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/join'
    | '/qr'
    | '/about-us'
    | '/privacy'
    | '/terms'
    | '/'
    | '/org/$orgId'
    | '/ticket/$ticketId'
    | '/ticket/scanner'
    | '/org/create'
    | '/home'
    | '/org/$orgId/preview'
    | '/user/$id/quiz'
    | '/user/$id/profile'
    | '/user/$id/wallet'
    | '/org/$orgId/'
    | '/org/$orgId/event/$eventId'
    | '/org/$orgId/location/create'
    | '/org/$orgId/edit'
    | '/org/$orgId/event'
    | '/org/$orgId/locations'
    | '/org/$orgId/members'
    | '/org/$orgId/referrals'
    | '/org/$orgId/event/$eventId/'
    | '/org/$orgId/event/create'
    | '/org/$orgId/event/$eventId/attendees'
    | '/org/$orgId/event/$eventId/edit'
    | '/org/$orgId/event/$eventId/questions'
    | '/org/$orgId/event/$eventId/sessions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/join'
    | '/qr'
    | '/about-us'
    | '/privacy'
    | '/terms'
    | '/'
    | '/ticket/$ticketId'
    | '/ticket/scanner'
    | '/org/create'
    | '/home'
    | '/org/$orgId/preview'
    | '/user/$id/quiz'
    | '/user/$id/profile'
    | '/user/$id/wallet'
    | '/org/$orgId'
    | '/org/$orgId/location/create'
    | '/org/$orgId/edit'
    | '/org/$orgId/event'
    | '/org/$orgId/locations'
    | '/org/$orgId/members'
    | '/org/$orgId/referrals'
    | '/org/$orgId/event/$eventId'
    | '/org/$orgId/event/create'
    | '/org/$orgId/event/$eventId/attendees'
    | '/org/$orgId/event/$eventId/edit'
    | '/org/$orgId/event/$eventId/questions'
    | '/org/$orgId/event/$eventId/sessions'
  id:
    | '__root__'
    | '/_auth'
    | '/join'
    | '/qr'
    | '/_info/about-us'
    | '/_info/privacy'
    | '/_info/terms'
    | '/_landing/'
    | '/_auth/org/$orgId'
    | '/_auth/ticket/$ticketId'
    | '/_auth/ticket/scanner'
    | '/_auth/org/create'
    | '/_auth/home/'
    | '/_auth/org/$orgId/preview'
    | '/_auth/user/$id/quiz'
    | '/_auth/user/$id/profile'
    | '/_auth/user/$id/wallet'
    | '/_auth/org/$orgId/'
    | '/_auth/org/$orgId/event/$eventId'
    | '/_auth/org/$orgId/location/create'
    | '/_auth/org/$orgId/edit/'
    | '/_auth/org/$orgId/event/'
    | '/_auth/org/$orgId/locations/'
    | '/_auth/org/$orgId/members/'
    | '/_auth/org/$orgId/referrals/'
    | '/_auth/org/$orgId/event/$eventId/'
    | '/_auth/org/$orgId/event/create/'
    | '/_auth/org/$orgId/event/$eventId/attendees/'
    | '/_auth/org/$orgId/event/$eventId/edit/'
    | '/_auth/org/$orgId/event/$eventId/questions/'
    | '/_auth/org/$orgId/event/$eventId/sessions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  JoinRoute: typeof JoinRoute
  QrLazyRoute: typeof QrLazyRoute
  InfoAboutUsLazyRoute: typeof InfoAboutUsLazyRoute
  InfoPrivacyLazyRoute: typeof InfoPrivacyLazyRoute
  InfoTermsLazyRoute: typeof InfoTermsLazyRoute
  LandingIndexLazyRoute: typeof LandingIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/qr': {
      id: '/qr'
      path: '/qr'
      fullPath: '/qr'
      preLoaderRoute: typeof QrLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_landing/': {
      id: '/_landing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LandingIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_info/terms': {
      id: '/_info/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof InfoTermsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_info/privacy': {
      id: '/_info/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof InfoPrivacyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_info/about-us': {
      id: '/_info/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof InfoAboutUsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/home/': {
      id: '/_auth/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/org/create': {
      id: '/_auth/org/create'
      path: '/org/create'
      fullPath: '/org/create'
      preLoaderRoute: typeof AuthOrgCreateLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/ticket/scanner': {
      id: '/_auth/ticket/scanner'
      path: '/ticket/scanner'
      fullPath: '/ticket/scanner'
      preLoaderRoute: typeof AuthTicketScannerRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/ticket/$ticketId': {
      id: '/_auth/ticket/$ticketId'
      path: '/ticket/$ticketId'
      fullPath: '/ticket/$ticketId'
      preLoaderRoute: typeof AuthTicketTicketIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/org/$orgId': {
      id: '/_auth/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof AuthOrgOrgIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/org/$orgId/': {
      id: '/_auth/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof AuthOrgOrgIdIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/user/$id/wallet': {
      id: '/_auth/user/$id/wallet'
      path: '/user/$id/wallet'
      fullPath: '/user/$id/wallet'
      preLoaderRoute: typeof AuthUserIdWalletLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/user/$id/profile': {
      id: '/_auth/user/$id/profile'
      path: '/user/$id/profile'
      fullPath: '/user/$id/profile'
      preLoaderRoute: typeof AuthUserIdProfileLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/user/$id/quiz': {
      id: '/_auth/user/$id/quiz'
      path: '/user/$id/quiz'
      fullPath: '/user/$id/quiz'
      preLoaderRoute: typeof AuthUserIdQuizRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/org/$orgId/preview': {
      id: '/_auth/org/$orgId/preview'
      path: '/preview'
      fullPath: '/org/$orgId/preview'
      preLoaderRoute: typeof AuthOrgOrgIdPreviewRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/referrals/': {
      id: '/_auth/org/$orgId/referrals/'
      path: '/referrals'
      fullPath: '/org/$orgId/referrals'
      preLoaderRoute: typeof AuthOrgOrgIdReferralsIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/members/': {
      id: '/_auth/org/$orgId/members/'
      path: '/members'
      fullPath: '/org/$orgId/members'
      preLoaderRoute: typeof AuthOrgOrgIdMembersIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/locations/': {
      id: '/_auth/org/$orgId/locations/'
      path: '/locations'
      fullPath: '/org/$orgId/locations'
      preLoaderRoute: typeof AuthOrgOrgIdLocationsIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/event/': {
      id: '/_auth/org/$orgId/event/'
      path: '/event'
      fullPath: '/org/$orgId/event'
      preLoaderRoute: typeof AuthOrgOrgIdEventIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/edit/': {
      id: '/_auth/org/$orgId/edit/'
      path: '/edit'
      fullPath: '/org/$orgId/edit'
      preLoaderRoute: typeof AuthOrgOrgIdEditIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/location/create': {
      id: '/_auth/org/$orgId/location/create'
      path: '/location/create'
      fullPath: '/org/$orgId/location/create'
      preLoaderRoute: typeof AuthOrgOrgIdLocationCreateLazyRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/event/$eventId': {
      id: '/_auth/org/$orgId/event/$eventId'
      path: '/event/$eventId'
      fullPath: '/org/$orgId/event/$eventId'
      preLoaderRoute: typeof AuthOrgOrgIdEventEventIdRouteRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/event/create/': {
      id: '/_auth/org/$orgId/event/create/'
      path: '/event/create'
      fullPath: '/org/$orgId/event/create'
      preLoaderRoute: typeof AuthOrgOrgIdEventCreateIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdRouteRoute
    }
    '/_auth/org/$orgId/event/$eventId/': {
      id: '/_auth/org/$orgId/event/$eventId/'
      path: '/'
      fullPath: '/org/$orgId/event/$eventId/'
      preLoaderRoute: typeof AuthOrgOrgIdEventEventIdIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdEventEventIdRouteRoute
    }
    '/_auth/org/$orgId/event/$eventId/sessions/': {
      id: '/_auth/org/$orgId/event/$eventId/sessions/'
      path: '/sessions'
      fullPath: '/org/$orgId/event/$eventId/sessions'
      preLoaderRoute: typeof AuthOrgOrgIdEventEventIdSessionsIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdEventEventIdRouteRoute
    }
    '/_auth/org/$orgId/event/$eventId/questions/': {
      id: '/_auth/org/$orgId/event/$eventId/questions/'
      path: '/questions'
      fullPath: '/org/$orgId/event/$eventId/questions'
      preLoaderRoute: typeof AuthOrgOrgIdEventEventIdQuestionsIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdEventEventIdRouteRoute
    }
    '/_auth/org/$orgId/event/$eventId/edit/': {
      id: '/_auth/org/$orgId/event/$eventId/edit/'
      path: '/edit'
      fullPath: '/org/$orgId/event/$eventId/edit'
      preLoaderRoute: typeof AuthOrgOrgIdEventEventIdEditIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdEventEventIdRouteRoute
    }
    '/_auth/org/$orgId/event/$eventId/attendees/': {
      id: '/_auth/org/$orgId/event/$eventId/attendees/'
      path: '/attendees'
      fullPath: '/org/$orgId/event/$eventId/attendees'
      preLoaderRoute: typeof AuthOrgOrgIdEventEventIdAttendeesIndexRouteImport
      parentRoute: typeof AuthOrgOrgIdEventEventIdRouteRoute
    }
  }
}

interface AuthOrgOrgIdEventEventIdRouteRouteChildren {
  AuthOrgOrgIdEventEventIdIndexRoute: typeof AuthOrgOrgIdEventEventIdIndexRoute
  AuthOrgOrgIdEventEventIdAttendeesIndexRoute: typeof AuthOrgOrgIdEventEventIdAttendeesIndexRoute
  AuthOrgOrgIdEventEventIdEditIndexRoute: typeof AuthOrgOrgIdEventEventIdEditIndexRoute
  AuthOrgOrgIdEventEventIdQuestionsIndexRoute: typeof AuthOrgOrgIdEventEventIdQuestionsIndexRoute
  AuthOrgOrgIdEventEventIdSessionsIndexRoute: typeof AuthOrgOrgIdEventEventIdSessionsIndexRoute
}

const AuthOrgOrgIdEventEventIdRouteRouteChildren: AuthOrgOrgIdEventEventIdRouteRouteChildren =
  {
    AuthOrgOrgIdEventEventIdIndexRoute: AuthOrgOrgIdEventEventIdIndexRoute,
    AuthOrgOrgIdEventEventIdAttendeesIndexRoute:
      AuthOrgOrgIdEventEventIdAttendeesIndexRoute,
    AuthOrgOrgIdEventEventIdEditIndexRoute:
      AuthOrgOrgIdEventEventIdEditIndexRoute,
    AuthOrgOrgIdEventEventIdQuestionsIndexRoute:
      AuthOrgOrgIdEventEventIdQuestionsIndexRoute,
    AuthOrgOrgIdEventEventIdSessionsIndexRoute:
      AuthOrgOrgIdEventEventIdSessionsIndexRoute,
  }

const AuthOrgOrgIdEventEventIdRouteRouteWithChildren =
  AuthOrgOrgIdEventEventIdRouteRoute._addFileChildren(
    AuthOrgOrgIdEventEventIdRouteRouteChildren,
  )

interface AuthOrgOrgIdRouteRouteChildren {
  AuthOrgOrgIdPreviewRoute: typeof AuthOrgOrgIdPreviewRoute
  AuthOrgOrgIdIndexRoute: typeof AuthOrgOrgIdIndexRoute
  AuthOrgOrgIdEventEventIdRouteRoute: typeof AuthOrgOrgIdEventEventIdRouteRouteWithChildren
  AuthOrgOrgIdLocationCreateLazyRoute: typeof AuthOrgOrgIdLocationCreateLazyRoute
  AuthOrgOrgIdEditIndexRoute: typeof AuthOrgOrgIdEditIndexRoute
  AuthOrgOrgIdEventIndexRoute: typeof AuthOrgOrgIdEventIndexRoute
  AuthOrgOrgIdLocationsIndexRoute: typeof AuthOrgOrgIdLocationsIndexRoute
  AuthOrgOrgIdMembersIndexRoute: typeof AuthOrgOrgIdMembersIndexRoute
  AuthOrgOrgIdReferralsIndexRoute: typeof AuthOrgOrgIdReferralsIndexRoute
  AuthOrgOrgIdEventCreateIndexRoute: typeof AuthOrgOrgIdEventCreateIndexRoute
}

const AuthOrgOrgIdRouteRouteChildren: AuthOrgOrgIdRouteRouteChildren = {
  AuthOrgOrgIdPreviewRoute: AuthOrgOrgIdPreviewRoute,
  AuthOrgOrgIdIndexRoute: AuthOrgOrgIdIndexRoute,
  AuthOrgOrgIdEventEventIdRouteRoute:
    AuthOrgOrgIdEventEventIdRouteRouteWithChildren,
  AuthOrgOrgIdLocationCreateLazyRoute: AuthOrgOrgIdLocationCreateLazyRoute,
  AuthOrgOrgIdEditIndexRoute: AuthOrgOrgIdEditIndexRoute,
  AuthOrgOrgIdEventIndexRoute: AuthOrgOrgIdEventIndexRoute,
  AuthOrgOrgIdLocationsIndexRoute: AuthOrgOrgIdLocationsIndexRoute,
  AuthOrgOrgIdMembersIndexRoute: AuthOrgOrgIdMembersIndexRoute,
  AuthOrgOrgIdReferralsIndexRoute: AuthOrgOrgIdReferralsIndexRoute,
  AuthOrgOrgIdEventCreateIndexRoute: AuthOrgOrgIdEventCreateIndexRoute,
}

const AuthOrgOrgIdRouteRouteWithChildren =
  AuthOrgOrgIdRouteRoute._addFileChildren(AuthOrgOrgIdRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthOrgOrgIdRouteRoute: typeof AuthOrgOrgIdRouteRouteWithChildren
  AuthTicketTicketIdRoute: typeof AuthTicketTicketIdRoute
  AuthTicketScannerRoute: typeof AuthTicketScannerRoute
  AuthOrgCreateLazyRoute: typeof AuthOrgCreateLazyRoute
  AuthHomeIndexLazyRoute: typeof AuthHomeIndexLazyRoute
  AuthUserIdQuizRoute: typeof AuthUserIdQuizRoute
  AuthUserIdProfileLazyRoute: typeof AuthUserIdProfileLazyRoute
  AuthUserIdWalletLazyRoute: typeof AuthUserIdWalletLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthOrgOrgIdRouteRoute: AuthOrgOrgIdRouteRouteWithChildren,
  AuthTicketTicketIdRoute: AuthTicketTicketIdRoute,
  AuthTicketScannerRoute: AuthTicketScannerRoute,
  AuthOrgCreateLazyRoute: AuthOrgCreateLazyRoute,
  AuthHomeIndexLazyRoute: AuthHomeIndexLazyRoute,
  AuthUserIdQuizRoute: AuthUserIdQuizRoute,
  AuthUserIdProfileLazyRoute: AuthUserIdProfileLazyRoute,
  AuthUserIdWalletLazyRoute: AuthUserIdWalletLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  JoinRoute: JoinRoute,
  QrLazyRoute: QrLazyRoute,
  InfoAboutUsLazyRoute: InfoAboutUsLazyRoute,
  InfoPrivacyLazyRoute: InfoPrivacyLazyRoute,
  InfoTermsLazyRoute: InfoTermsLazyRoute,
  LandingIndexLazyRoute: LandingIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
